module.exports = __webpack_public_path__ + "static/showroomBottles-e9c2749f12f5a48ecab951c81d546fa6.jpg";